require("prototype-extensions/js/DomExtensions");

const Measurement = require('graph-netecs/js/Measurement').Measurement;
const fanGraphs = require('./fanGraphs').fanGraphs;
const fanSummary = require('./fanSummary').fanSummary;
const VerticalMeasureLine = require('graph-netecs/js/VerticalMeasureLine').VerticalMeasureLine;
const HorizontalMeasureLine = require('graph-netecs/js/HorizontalMeasureLine').HorizontalMeasureLine;
const measurementsAbstract = require('./measurementsAbstract').measurementsAbstract;
const Ppm = require('./ppm').default;
const GraphPoint = require('graph/js/Point').Point;
const Polynomial = require('mathFunctions/js/Polynomial').Polynomial;
const PolynomialLine = require('graph-netecs/js/PolynomialLine').PolynomialLine;
const HSLA = require('./colors').HSLA;
const AColorPicker = require('a-color-picker');
const unit = require('./unit').unit;
const Value = require('graph/js/Value').Value;
const debounce = require('lodash.debounce');

const measurementShow = Object.create(measurementsAbstract);
/**
 * widok podglądu pomiaru
 */
Object.assign(measurementShow, {
    init(store, selectedGraphs = null) {
        this.store = store;
        unit.setPrototypeOfUnits();
        unit.clearAxisByTypes();
        this.userFilters = false;
        this.AxisColors = [
            new HSLA(220, 60, 65, 1),
            new HSLA(150, 100, 40, 1),
            new HSLA(24, 100, 50, 1),
            new HSLA(309, 63, 33, 1)
        ];

        let x = JSON.parse("{\"id\":\"123\",\"measurement_number\":\"P00341\",\"range_min\":1.15,\"range_max\":6.2830603812782,\"avg_nominal_speed\":\"2950\",\"flag_archived\":\"0\",\"category\":\"C\",\"rotor_type\":\"closed\",\"rotor_diameter\":\"625\",\"blades_amount\":\"8\",\"engine_rpm\":\"3000\",\"outlet\":\"rectangle\",\"outlet_a\":500,\"outlet_b\":250,\"avg_inlet\":\"349\",\"outlet_diameter\":\"0\",\"comment\":\"\",\"comment_enabled\":\"0\",\"characteristic\":{\"TotalPressure\":{\"id\":\"1124\",\"id_measurement\":\"123\",\"type\":\"TotalPressure\",\"a0\":5644.1,\"a1\":647.38,\"a2\":-239.43,\"a3\":5.0647},\"PowerOnShaft\":{\"id\":\"1125\",\"id_measurement\":\"123\",\"type\":\"PowerOnShaft\",\"a0\":7.7966,\"a1\":4.9238,\"a2\":-0.2445,\"a3\":-0.0153},\"Noise\":{\"id\":\"1126\",\"id_measurement\":\"123\",\"type\":\"Noise\",\"a0\":105.74,\"a1\":-2.1871,\"a2\":-1.6754,\"a3\":0.359}}}");

        this.data = new Measurement();

        Object.assign(this.data, store.state.selectedFan);

        this.form = document.querySelector('.measurementShow');

        if (this.form) {
            this.form.addEventListener('change', () => this.calc());
            this.form.addEventListener('keyup', e => {
                if (!e.target.findParent(x => x.classList.contains('detailsAnalize'))) this.calc()
            });
            this.form.addEventListener('keypress', e => {
                if (!e.target.findParent(x => x.classList.contains('detailsAnalize'))) this.calc()
            });
            this.form.addEventListener('blur', e => {
                if (!e.target.findParent(x => x.classList.contains('detailsAnalize'))) this.calc()
            });
        }

        this.filterElements = [
            // this.form.summaryStaticPressure,
            // this.form.summaryTotalPressure,
            // this.form.summaryPowerOnShaft,
            // this.form.summaryPowerOnShaftWithMaterial
        ];

        this.setFilterElementsEvents();

        let graphChangedCallback = () => {//gdy wewnatrz wykresów coś sie zmieni i trzeba wsyztsko odświerzyć np. przeciągnięto ciśnienie
            this.unloadData();
            this.refreshAmountUnit();
            this.calc();
        };

        this.graphsSummary = new fanSummary(document.querySelector('.fanGraphSummary'), this.data, store);//wykres zbiorczy

        this.graphsObj = new fanGraphs(document.querySelector('.fanGraphs'), this.data, this.store, selectedGraphs);//wykresy zwykłe (te same co w edycji)

        for (const graph of Object.values(this.graphsObj.graphs)) {
            graph.graph.mouseMove(e => this.readResults(e));//odczyt do analizy sczegółowej jak jeździmy myszą
            graph.html.addEventListener('mouseleave', e => {
                this.readResults(null);//jak zjedziemy myszą to myślniki wyświetla
            })
        }
        this.graphsObj.validityChanged(e => {
            let input = this.form[e.inputName];
            if (input) {
                if (e.isValid)
                    this.form[e.inputName].classList.remove("errorFloat");
                else
                    this.form[e.inputName].classList.add("errorFloat");
            }
        });

        this.initEvents();
        this.calc(true);

        this.graphsSummary.changed(graphChangedCallback);
        this.graphsObj.changed(graphChangedCallback);
    },

    refreshAxis() {
        let context = this;

        for (let line of Object.values(this.graphsSummary.fanRecalced.lines)) {
            let axis = line.line.ys;
            let containerId = 0;

            for (let filtId in this.store.state.partsOfTheGraph.mainAxisParams) {
                let filt = this.store.state.partsOfTheGraph.mainAxisParams[filtId];
                let selectedColor = this.AxisColors[containerId];

                if (axis && filt.specificParts) {
                    if (filt.active) {
                        let curentAxis = this.graphsSummary.graph.getAxisByKind(filtId);
                        this.graphsSummary.graph.graph.setMainAxis(curentAxis);
                    }

                    for (let curentLineID in filt.specificParts) {
                        let curentLine = filt.specificParts[curentLineID];

                        if (curentLineID == line.name) {
                            let axisColor = filt.color;

                            if (!curentLine.color)
                                curentLine.color = selectedColor.toString();

                            line.line.config = {color: curentLine.color};

                            if (!axisColor) {
                                axisColor = selectedColor.toString();
                            }

                            axis.config = {color: axisColor};

                            break;
                        }
                    }
                }

                containerId++;
            }

        }

    },
    /**
     * wczytuje dane do analizy szczegółowej
     * debounce ogranicza wykonanie funkcji po zakonczeniu ostatniego eventu mousemove
     * @param e gdy ruszamy mysza nad wykresem tu dajemy event mousemove
     */
    readResults: debounce(function(e = null) {
        this.readHorizontalResults(e);
        this.readVerticalResults(e);
        this.readFrequency();
        this.readAirDensity();
        this.readTemperature();
    }, 10),
    readFrequency() {
        let frequency = '-';
        if(this.graphsObj.workPointResult) {
             frequency = this.graphsObj.workPointResult.Frequency.toString().replace(".", ",");
        }
        if(this.store.state.detailsParams['Frequency']) {
            this.store.state.detailsParams["Frequency"].lines['_static'].value = frequency;
            this.store.state.detailsParams["Frequency"].lines['_static'].hidden = false;
            this.store.state.detailsParams["Frequency"].lines['_static'].editable = false;
        }
    },
    // NVS-149
    readAirDensity() {
        let air_density = '-';
        if(this.graphsObj.workPointResult) {
            air_density = this.graphsObj.workPointResult.AirDensity.toString().replace(".", ",");
        }
        if(this.store.state.detailsParams['AirDensity']) {
            this.store.state.detailsParams["AirDensity"].lines['_static'].value = air_density;
            this.store.state.detailsParams["AirDensity"].lines['_static'].hidden = false;
            this.store.state.detailsParams["AirDensity"].lines['_static'].editable = false;
        }
    },
    // NVS-149
    readTemperature() {
        let temperature = '-';
        if(this.graphsObj.workPointResult) {
            temperature = (this.store.state.fourthStepParameters.temperature.value - 273.15).toFixed(unitsList.temperature.list[0].decimal_places).toString().replace(".", ",");
        }
        if(this.store.state.detailsParams['Temperature']) {
            this.store.state.detailsParams["Temperature"].lines['_static'].value = temperature;
            this.store.state.detailsParams["Temperature"].lines['_static'].hidden = false;
            this.store.state.detailsParams["Temperature"].lines['_static'].editable = false;
        }
    },
    /**
     * wczytuje dane rzędnych i kursora myszy do analizy szczegółowej
     * @param e gdy ruszamy mysza nad wykresem tu dajemy event mousemove
     */
    readVerticalResults(e = null) {
        let _this = this;
        let workPointOryginalChecked = this.store && this.store.state.detailsShowOryginalFrequency;
        let results = [];

        if(this.graphsObj.fan.lines.TotalPressure) {
            if (e && e.isOnPlane) {
                results.push({color: "black", mouse: true, data: this.graphsObj.getDataByX(e.x)});
            } else {
                results.push({color: "black", mouse: true, data: this.graphsObj.getDataByX(Number.NaN)});
            }
        }

        for (const name in this.graphsObj.graphs) {
            let graph = this.graphsObj.graphs[name];
            for (const line of graph.measureLines) {
                if (line instanceof VerticalMeasureLine) {
                    let dataByX = this.graphsObj.getDataByX(line.x);

                    dataByX.Performance = line.x;
                    results.push({line: line, color: line.color, data: dataByX});
                }
            }
        }

        let addedResults = [];
        let lineStrtIndex = 5;
        let indexOfLine = [];

        for (const result of results) {

            for (let lineName in result.data) {
                if (!indexOfLine[lineName])
                    indexOfLine[lineName] = {index: lineStrtIndex, values: []};

                let lineIndex = indexOfLine[lineName].index;

                indexOfLine[lineName].index++;


                if (result.mouse && this.store.state.detailsParams[lineName] && this.store.state.detailsParams[lineName].lines["_mouse"]) {
                    let recalced = result.data.recalced[lineName] !== undefined && Number.isFinite(result.data.recalced[lineName].value) ? (new Value(result.data.recalced[lineName].value, '', result.data[lineName].unit)) : '-';

                    this.store.state.detailsParams[lineName].lines["_mouse"].editable = false;
                    this.store.state.detailsParams[lineName].lines["_mouse"].hidden = false;
                    this.store.state.detailsParams[lineName].lines["_mouse"].color = result.color;

                    if(this.store.state.detailsParams[lineName].lines["_mouse"].title != this.store.state.detailsParams[lineName].code)
                        this.store.state.detailsParams[lineName].lines["_mouse"].title = this.store.state.detailsParams[lineName].code;

                    if ((lineName == "Performance")) {
                        this.store.state.detailsParams[lineName].lines["_mouse"].value = (result.data[lineName] !== undefined && Number.isFinite(result.data[lineName].display)) ? this.formatValueFunction(result.data[lineName], 3) : '-';
                    } else {
                        let curentValue = this.formatValueFunction(result.data[lineName], 3);

                        this.store.state.detailsParams[lineName].lines["_mouse"].value = curentValue;

                    }
                } else {
                    if (lineName == "Performance" && !result.mouse) {
                        let valueOfInput = result.data[lineName];

                        if (result.data[lineName].unit.flag_default != "1") {
                            valueOfInput = result.data[lineName].unit.restore(result.data[lineName]);
                        }

                        valueOfInput = new Value(valueOfInput, '', _this.store.state.ValueUnitMap.performance.selected.unit);


                        valueOfInput = this.formatValueFunction(valueOfInput, 3);

                        let existElement = indexOfLine[lineName].values.find(x => x.value == valueOfInput && x.color == result.line.color);

                        if (!existElement) {
                            indexOfLine[lineName].values.push({value: valueOfInput, color: result.line.color});

                            _this.store.state.detailsParams[lineName].lines[lineName + lineIndex].value = valueOfInput;
                            _this.store.state.detailsParams[lineName].lines[lineName + lineIndex].color = result.line.color;
                            _this.store.state.detailsParams[lineName].lines[lineName + lineIndex].hidden = false;
                            _this.store.state.detailsParams[lineName].lines[lineName + lineIndex].onchange = (value) => {
                                let parsedValueInUnit = Number.parse(value);

                                let parsedValue = _this.store.state.ValueUnitMap.performance.selected.unit.restore(parsedValueInUnit);

                                if (parsedValue > this.graphsObj.fanActive.max) {
                                    parsedValue = this.graphsObj.fanActive.max;
                                } else if (parsedValue < this.graphsObj.fanActive.min) {
                                    parsedValue = this.graphsObj.fanActive.min;
                                }

                                result.line.x = result.line.x.createSimilar(parsedValue);

                                _this.store.state.detailsParams[lineName].lines[lineName + lineIndex].value = this.formatValueFunction(new Value(parsedValue, '', _this.store.state.ValueUnitMap.performance.selected.unit), 3);
                            };
                        } else {
                            indexOfLine[lineName].index--;
                        }
                    } else {
                        if (_this.store.state.detailsParams[lineName] && !result.mouse) {
                            let recalced = result.data.recalced[lineName] !== undefined && Number.isFinite(result.data.recalced[lineName].value) ? (new Value(result.data.recalced[lineName].value, '', result.data[lineName].unit)) : '-';
                            let valueOfInput = result.data[lineName];

                            let recalcedValue = recalced != "-" ? this.formatValueFunction(recalced, 3) : recalced;
                            valueOfInput = this.formatValueFunction(valueOfInput, 3);

                            let existElement = indexOfLine[lineName].values.find(x => x.value == valueOfInput && x.color == result.line.color);

                            if (!existElement) {
                                indexOfLine[lineName].values.push({value: valueOfInput, color: result.line.color});

                                _this.store.state.detailsParams[lineName].lines["Performance" + lineIndex].value_hz = recalcedValue;
                                _this.store.state.detailsParams[lineName].lines["Performance" + lineIndex].value = valueOfInput;
                                _this.store.state.detailsParams[lineName].lines["Performance" + lineIndex].color = result.line.color;
                                _this.store.state.detailsParams[lineName].lines["Performance" + lineIndex].hidden = false;
                                _this.store.state.detailsParams[lineName].lines["Performance" + lineIndex].title = "performance";
                            } else {
                                indexOfLine[lineName].index--;
                            }
                        } else {
                            indexOfLine[lineName].index--;
                        }

                    }
                }
            }

        }
    },
    formatValueFunction(Value, defaultFormat = 3) {

        let unit = Value.unit;

        if (unit) {
            if (unit.name == "Kilowat" && Value.oryginal < 1) {
                return Value.oryginal.format(2);
            } else {
                return Value.display.format(defaultFormat);
            }
        } else {
            return Value;
        }
    },
    /**
     * linie odcietych w analizie szczegółowej
     */
    readHorizontalResults(e = null) {
        let _this = this;
        let results = [];

        for (let lineTmp in this.store.state.detailsParams) {
            for (let lineTmp2 in this.store.state.detailsParams[lineTmp].lines) {
                if (lineTmp2 != "_mouse")
                    this.store.state.detailsParams[lineTmp].lines[lineTmp2].hidden = true;

                this.store.state.detailsParams[lineTmp].lines[lineTmp2].value = "-";
                this.store.state.detailsParams[lineTmp].lines[lineTmp2].value_hz = "-";
            }
        }

        for (const name in this.graphsObj.graphs) {
            let lineIndex = 5;
            let index = 0;
            let index2 = 0;
            let isActive = null;

            let graph = this.graphsObj.graphs[name];
            for (const line of graph.measureLines) {
                if (line instanceof HorizontalMeasureLine) {
                    let dataByY = graph.getDataByY(line.y);
                    for (const lineResult of dataByY) {
                        if (lineResult.x.length == 0) continue;
                        if (lineResult.line.title === undefined) continue;
                        
                        let items = [];
                        let needAdd = true;
                        let divValue = lineResult.x[0].display.format(3);

                        for (let item of items) {
                            let finded = Array.prototype.filter.call(item.querySelectorAll('div'), x => x.textContent == divValue);

                            if (finded.length > 0) {
                                needAdd = false;
                                //ustawić kolorek
                                if (lineResult.line.isActive) {
                                    finded[0].parentElement.style.background = "white";
                                }
                            }
                        }

                        if (isActive != lineResult.line.isActive) {
                            isActive = lineResult.line.isActive;
                            index = 0 + index2;
                        }


                        for (let a of lineResult.x) {

                            if (_this.store.state.detailsParams['Performance'].lines[lineResult.line.name + index]) {
                                _this.store.state.detailsParams['Performance'].lines[lineResult.line.name + index].editable = false;
                                _this.store.state.detailsParams['Performance'].lines[lineResult.line.name + index].hidden = false;
                                _this.store.state.detailsParams['Performance'].lines[lineResult.line.name + index].color = line.color;
                                _this.store.state.detailsParams['Performance'].lines[lineResult.line.name + index].title = lineResult.line.title;

                                if (lineResult.line.isActive == false) {
                                    _this.store.state.detailsParams['Performance'].lines[lineResult.line.name + index].value_hz = a.display.format(3);
                                } else {

                                    _this.store.state.detailsParams['Performance'].lines[lineResult.line.name + index].value = a.display.format(3);
                                }


                                _this.store.state.detailsParams['Performance'].lines[lineResult.line.name + index].elements = {
                                    0: {
                                        unit: "m3/h",
                                        active: true
                                    },

                                    1: {
                                        unit: "m3/s",
                                        active: false
                                    }
                                };
                            } else {
                                _this.store.state.detailsParams['Performance'].lines[lineResult.line.name + index] = {

                                    editable: false,
                                    color: line.color,
                                    title: lineResult.line.title,
                                    value: a.display.format(3),
                                    value_hz: a.display.format(3) + index,
                                    elements: {
                                        0: {
                                            unit: "m3/h",
                                            active: true
                                        },

                                        1: {
                                            unit: "m3/s",
                                            active: false
                                        }
                                    },
                                }
                            }
                            index++;
                        }
                    }


                    let linesToShowInputs = [];
                    linesToShowInputs.push(dataByY[0]);

                    if (dataByY[0].line.name == "DynamicPressure" && dataByY.length > 1) {
                        linesToShowInputs.push(dataByY[1]);
                    }

                    for (let lineToShow of linesToShowInputs) {

                        _this.store.state.detailsParams[lineToShow.line.name].lines[lineToShow.line.name + lineIndex].value = this.formatValueFunction(lineToShow.y, 3);
                        _this.store.state.detailsParams[lineToShow.line.name].lines[lineToShow.line.name + lineIndex].color = line.color;
                        _this.store.state.detailsParams[lineToShow.line.name].lines[lineToShow.line.name + lineIndex].hidden = false;
                        _this.store.state.detailsParams[lineToShow.line.name].lines[lineToShow.line.name + lineIndex].onchange = (value) => {
                            let unit = lineToShow.line.line.ys.getConfigValue('unit');
                            let parsedValueInUnit = Number.parse(value);
                            let parsedValue = unit.restore(parsedValueInUnit);

                            let {min, max} = lineToShow.line.calcMinMax(this.graphsObj.fanActive.min, this.graphsObj.fanActive.max);
                            if (parsedValue > max) {
                                parsedValue = max;
                            } else if (parsedValue < min) {
                                parsedValue = min;
                            }

                            line.y = new Value(parsedValue, '', unit);

                            _this.store.state.detailsParams[lineToShow.line.name].lines[lineToShow.line.name + lineIndex].value = this.formatValueFunction(line.y, 3);
                        };
                    }


                    index++;
                    index2 = index;
                }
                index++;
                lineIndex++;
            }
        }
        _this.store.state.detailsParamsUpdateTime = Date.now();
    },
    /**
     * przeprowadza wsyztskei obliczenia i aktualizuje dane i wykresy
     * wykonywane zawsze jak coś się zmieni
     */
    calc(firstCalc = false) {
        // this.loadData();
        this.setFilters();
        this.data.calcArea();
        this.data.limitValues();
        this.workPointAirDensityTotal();
        this.graphsSummary.draw();

        if (this.data.characteristic.TotalPressure)
            this.graphsObj.draw();

        if(this.graphsSummary.graph.graph.svg) {
            if (this.graphsSummary.canDraw) {
                this.graphsSummary.graph.graph.svg.style.display = "block";
            } else {
                this.graphsSummary.graph.graph.svg.style.display = "none";
            }

            this.refreshAxis();
            this.unloadData(firstCalc);
            this.setWorkPointResults();

            this.readResults();
        }

    },
    setFilters(filter) {
        if (!this.userFilters) {
            this.resetFilters();
            switch (this.data.workPointPressureType) {
                case "static":
                    this.data.summaryStaticPressure = true;
                    break;
                case  "total":
                    this.data.summaryTotalPressure = true;
                    break;

            }
            if (this.data.workPointAmount) {
                this.data.summaryPowerOnShaftWithMaterial = true;
            } else {
                this.data.summaryPowerOnShaft = true;
            }
        }
    },

    resetFilters() {
        for (let filterElement of this.filterElements) {
            this.data[filterElement.name] = false;
        }
    },
    setFilterElementsEvents() {
        for (let filterElement of this.filterElements) {
            filterElement.onclick = () => {
                this.userFilters = true;
            };
        }
    },
});
export {measurementShow};